import { Box, CircularProgress, Grid } from "@mui/material";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import { useState } from "react";
import { IconOnButton } from "../../../../components/button/Button";
import Input, { IOptions } from "../../../../components/input/Input-v2";
import { ToMoneyFormat, FromStringToDate } from "../../../../utils/Helper";
import {
  IPDF_SIMPEL_DATA,
  IPDF_TIKET_DATA,
  IPDF_RESMI_DATA,
  IPDF_SURAT_JALAN_DATA,
} from "../../hooks/pdf/generateInvoice.type";
// import { loadImageAsBase64 } from "../../hooks/pdf/InvoiceGeneratorUtils";
import useGenerateInvoice from "../../hooks/pdf/useGenerateInvoice";
import { M_InvoiceDetail } from "../../type/Invoice.type";

interface PropsPrintInvoice {
  data: M_InvoiceDetail;
}

export default function PrintInvoice({ data }: PropsPrintInvoice) {
  const printOptions: IOptions[] = [
    { text: "Resmi", value: 2 },
    { text: "Surat Jalan", value: 3 },
  ];
  const [selectedPrint, setSelectedPrint] = useState<IOptions>(printOptions[0]);
  const [isLoading, setIsLoading] = useState(false);
  const { generateTiket, generateResmi, generateSuratJalan, generateSimpel } =
    useGenerateInvoice();
  const currentDate = new Date().toISOString();

  // Generate Simpel
  const handleGenerateSimpel = () => {
    const temp: IPDF_SIMPEL_DATA[] = [];
    data.invoice_detail.forEach((item) => {
      const total = item.price * item.quantity;
      temp.push({
        name: `${item.product.product_category.category_name}/${item.product.product_brand.brand_name}/
          ${item.product.product_type_name}`,
        price: ToMoneyFormat(item.price) || "",
        qty: item.quantity,
        unitType: item.product.unit_type,
        total: ToMoneyFormat(total) || "",
      });
    });
    generateSimpel({
      invoice: temp,
      invoiceNumber: data.invoice_number,
      customerName: data.customer_name,
      date: FromStringToDate(currentDate),
      total: ToMoneyFormat(data.grand_total) || "",
    });
  };

  // Generate Tiket
  const handleGenerateTiket = () => {
    const temp: IPDF_TIKET_DATA[] = [];
    data.invoice_detail.forEach((item) => {
      temp.push({
        name: item.product.product_type_name,
        qty: item.quantity,
        unitType: item.product.unit_type,
      });
    });
    generateTiket({
      invoice: temp,
      customerName: data.customer_name,
      shopName: data.customer_name,
      date: FromStringToDate(currentDate),
    });
  };

  // Generate Resmi
  const handleGenerateResmi = async () => {
    setIsLoading(true);
    const temp: IPDF_RESMI_DATA[] = [];
    data.invoice_detail.forEach((item) => {
      const total = item.price * item.quantity;
      temp.push({
        name: generateName(
          item.product.product_category?.category_name,
          item.product.product_brand?.brand_name,
          item.product.product_type_name
        ),
        price: ToMoneyFormat(item.price) || "",
        qty: item.quantity,
        unitType: item.product.unit_type,
        total: ToMoneyFormat(total) || "",
      });
    });
    // const base64Image: any = await loadImageAsBase64("/logo.png");
    await generateResmi({
      logo: "",
      invoice: temp,
      invoiceNumber: data.invoice_number,
      companyAddress: "Jl Akibalak rt68 no38",
      companyName: "CV. Sumber Jaya Elektronik",
      companyPhone: "HP.0812 5411 6467 , 0812 5817 686",
      companyLocation: "TARAKAN 77111 - KALIMANTAN UTARA",
      total: ToMoneyFormat(data.grand_total) || "",
      customerName: data.customer_name,
      customerAddress: data.customer_address,
      customerPhone: data.customer_phone_number,
      shopName: data.customer_name,
      date: FromStringToDate(data.invoice_date),
    });
    setIsLoading(false);
  };

  // Generate Surat Jalan
  const handleGenerateSuratJalan = async () => {
    setIsLoading(true);
    const temp: IPDF_SURAT_JALAN_DATA[] = [];
    data.invoice_detail.forEach((item) => {
      temp.push({
        name: generateName(
          item.product.product_category?.category_name,
          item.product.product_brand?.brand_name,
          item.product.product_type_name
        ),
        qty: item.quantity,
        unitType: item.product.unit_type,
      });
    });
    // const base64Image: any = await loadImageAsBase64("/logo.png");
    await generateSuratJalan({
      logo: "",
      invoice: temp,
      invoiceNumber: data.invoice_number,
      companyAddress: "Jl Akibalak rt68 no38",
      companyName: "CV. Sumber Jaya Elektronik",
      companyPhone: "HP.0812 5411 6467 , 0812 5817 686",
      companyLocation: "TARAKAN 77111 - KALIMANTAN UTARA",
      customerName: data.customer_name,
      customerAddress: data.customer_address,
      customerPhone: data.customer_phone_number,
      date: FromStringToDate(data.invoice_date),
    });
    setIsLoading(false);
  };

  const handlePrintPDF = () => {
    switch (selectedPrint.text) {
      case "Simpel":
        handleGenerateSimpel();
        break;
      case "Tiket":
        handleGenerateTiket();
        break;
      case "Resmi":
        handleGenerateResmi();
        break;
      case "Surat Jalan":
        handleGenerateSuratJalan();
        break;
    }
  };

  const generateName = (category: string, brand: string, type: string) => {
    let temp = "";
    temp += category ? category + " - " : "";
    temp += brand ? brand + " - " : "";
    temp += type ? type : "";
    return temp;
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={10}>
        <Input.Select
          value={selectedPrint}
          label="Print"
          options={printOptions}
          onChange={(e) => setSelectedPrint(e)}
        />
      </Grid>
      <Grid item xs={2} display={"flex"} alignItems={"flex-end"}>
        <Box>
          {isLoading ? (
            <div>
              <CircularProgress
                disableShrink
                style={{ color: "orange" }}
                size={28}
              />
            </div>
          ) : (
            <IconOnButton
              icon={<LocalPrintshopIcon></LocalPrintshopIcon>}
              text="Cetak"
              handleClick={handlePrintPDF}
            />
          )}
        </Box>
      </Grid>
    </Grid>
  );
}
